import { IApplicationState } from '../../types/redux';

export function getOverallScore(state: IApplicationState) {
  return state.newReview.data.overallScore;
}

export function getPolite(state: IApplicationState) {
  return state.newReview.data.polite;
}

export function getPriceAndQuality(state: IApplicationState) {
  return state.newReview.data.priceAndQuality;
}

export function getLocation(state: IApplicationState) {
  return state.newReview.data.location;
}

export function getComfortAndAppliance(state: IApplicationState) {
  return state.newReview.data.comfortAndAppliance;
}

export function getCleaning(state: IApplicationState) {
  return state.newReview.data.cleaning;
}
